import { render, staticRenderFns } from "./piPackageDetail.vue?vue&type=template&id=5c613938&scoped=true"
import script from "./piPackageDetail.vue?vue&type=script&lang=ts"
export * from "./piPackageDetail.vue?vue&type=script&lang=ts"
import style0 from "./piPackageDetail.vue?vue&type=style&index=0&id=5c613938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c613938",
  null
  
)

export default component.exports